export default __webpack_public_path__ + "static/media/galarie1.4bf8cbf7.jpg";